<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-2"></div>
    </div>
    <div class="row">
      <div class="col-sm-1">아이디</div>
      <div class="col-sm-2">알림명</div>
      <div class="col-sm-2">알림라벨</div>
      <div class="col-sm-3">제목</div>
      <div class="col-sm-3">내용</div>
      <div class="col-sm-1">상세설정</div>
    </div>
    <hr />
    <div class="row handle" v-for="(item, index) in data">
      <div class="col-sm-1">{{ item.id }}</div>
      <div class="col-sm-2">{{ item.name }}</div>
      <div class="col-sm-2">{{ item.analyticsLabel }}</div>
      <div class="col-sm-3">{{ item.title }}</div>
      <div class="col-sm-3">{{ item.body }}</div>
      <div class="col-sm-1">
        <base-button @click.native="goNotificationTemplateForm(item.id)" type="warning" size="sm" icon>
          <i class="tim-icons icon-pin" />
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getData();
  },
  data() {
    return {
      data: [],
      currentPageAll: 1,
      totalPagesAll: null,
    };
  },
  methods: {
    async goNotificationTemplateForm(id) {
      await this.$router.push(`/notification/templateForm?id=${id}`);
    },
    async getData() {
      const path = `/notification/template`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      await this.$axios.get("/notification/template").then((res) => {
        this.data = res.data.data;
      });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
